import { render } from "./company-individual-contacts.vue?vue&type=template&id=17cf90a2&ts=true"
import script from "./company-individual-contacts.vue?vue&type=script&lang=ts"
export * from "./company-individual-contacts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__